import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Home from "./scenes/home/Home";
import Servicios from "./scenes/servicios/Servicios";
import Especialidades from "./scenes/especialidades/Especialidades";
import Salud365 from "./scenes/salud365/salud365";
import Contacto from "./scenes/contacto/Contacto";
import Seguros from "./scenes/seguros/Seguros";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const ScrollTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  useEffect(() => {
    if (document.getElementById("googleRecaptcha"))
    return;
    const script = document.createElement("script");
    script.id = "googleRecaptcha";
    script.src = "https://www.google.com/recaptcha/api.js?render=6Leb1M4rAAAAAP_gRcAyMiOo99-j6eqQajKuMlB9";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <Box className="app">
      <BrowserRouter>
        <Navbar />
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/medicos" element={<Especialidades />} />
          <Route path="/seguros" element={<Seguros />} />
          {/* <Route path="/salud365" element={<Salud365 />} /> */}
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </Box>
  );
}

export default App;
